import React from "react";
import styles from "./index.module.scss";
import { Button } from "../../components/Button";
import warningIcon from "../../../assets/images/WarningImg.svg";
import successIcon from "../../../assets/images/Infographic.svg";
import { AlertPopupProps } from "../../../types/registration";
import { CONFIRM } from "../../../constants";

const AlertPopup: React.FC<AlertPopupProps> = ({
  message,
  cancelText,
  confirmText = CONFIRM,
  onCancel,
  onConfirm,
  type
}) => {
  const iconSrc = type === "warning" ? warningIcon : successIcon;
  const showIcon = Boolean(type);

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.header}>
          {showIcon && (
            <div className={styles.icon}>
              <img src={iconSrc} alt="icon" />
            </div>
          )}
          {Array.isArray(message) ? (
            message.map((item, idx) => (
              <p key={idx} className={styles.message}>
                {item}
              </p>
            ))
          ) : (
            message && <p className={styles.message}>{message}</p>
          )}
        </div>

        <div className={styles.buttons}>
          {cancelText && (
            <button onClick={onCancel} className={styles.cancelButton}>
              {cancelText}
            </button>
          )}

          {onConfirm && (
            <Button
              onClick={onConfirm}
              buttonClassName={styles.confirmButton}
              buttonTextClassName={styles.cancelText}
              datatestid="alert-popup-confirm-button"
              datatestidText={confirmText}
            >
              {confirmText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertPopup;
